import type { TAsrExecutionAttempt, TAsrExecutionStage } from 'app/API/custom/asr-execution/types';
import { SUCCESS_FINAL_PHASE } from '../constants';
import type { TTranscriptionRouteOutcome } from '../types/TTranscriptionRouteOutcome';
import { getFailedRoutePhase } from './getFailedRoutePhase';

export const getTranscriptionRouteFinalPhase = (
  outcome: TTranscriptionRouteOutcome,
  stages?: TAsrExecutionStage[],
  attempts?: TAsrExecutionAttempt[],
): number => (outcome === 'response-failed' ? getFailedRoutePhase(stages, attempts) : SUCCESS_FINAL_PHASE);
